import React, { useEffect, useState } from 'react';

import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaTiktok,
  FaWhatsapp,
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaCcPaypal
} from 'react-icons/fa';

import {
  MdEmail,
  MdPhone,
  MdLocationOn
} from 'react-icons/md';

import {
  webDetails,
  serviceCategory,
  FILE_BASE_URL
} from '../api/api';

import { Link } from 'react-router';

function Footer() {

  const [webData, setWebData] = useState(null);
  const [servCat, serviCateg] = useState(null);

  useEffect(() => {

    webDetails()
      .then((res) => {
        setWebData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });

  }, []);

  useEffect(() => {

    serviceCategory()
      .then((res) => {
        serviCateg(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });

  }, []);

  const getQrUrl = (qrPath) => {

    if (!qrPath) {
      return "";
    }

    return `${FILE_BASE_URL}${qrPath.replace(/^\/+/, "")}`;
  };

  const copyLink = async (link) => {

    if (!link) {
      return;
    }

    try {

      await navigator.clipboard.writeText(link);

      alert("App link copied!");

    } catch (error) {

      console.log("Copy failed:", error);

    }

  };

  const socialLinks = [
    {
      icon: <FaFacebookF />,
      url: webData?.faceBook,
      color: "#1877f2"
    },
    {
      icon: <FaTwitter />,
      url: webData?.twitter,
      color: "#1da1f2"
    },
    {
      icon: <FaInstagram />,
      url: webData?.instagram,
      color: "#e4405f"
    },
    {
      icon: <FaTiktok />,
      url: webData?.youtube,
      color: "#000000"
    },
    {
      icon: <FaWhatsapp />,
      url: webData?.phone
        ? `https://wa.me/91${webData.phone}`
        : null,
      color: "#25d366"
    }
  ];

  const paymentIcons = [
    {
      icon: <FaCcVisa />,
      name: "Visa"
    },
    {
      icon: <FaCcMastercard />,
      name: "Mastercard"
    },
    {
      icon: <FaCcAmex />,
      name: "American Express"
    },
    {
      icon: <FaCcPaypal />,
      name: "PayPal"
    }
  ];

  const year = new Date().getFullYear();

  return (
    <>

      <footer className="app-footer">

        <div className="container footer-container">

          <div className="row g-4">

            {/* About */}
            <div className="col-lg-6 col-md-6 col-sm-6">

              <h3 className="footer-title">
                About Us
              </h3>

              <p>
                {webData?.aboutUsLong || "Loading..."}
              </p>

              <div className="social-section">

                <h5>
                  Follow Us
                </h5>

                <div className="social-links">

                  {socialLinks.map((social, index) => (

                    social.url && (

                      <a
                        key={index}
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                        style={{
                          '--social-color': social.color
                        }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background =
                            social.color;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background =
                            'rgba(255,255,255,0.1)';
                        }}
                      >
                        {social.icon}
                      </a>

                    )

                  ))}

                </div>

              </div>

            </div>

            {/* Categories */}
            <div className="col-lg-3 col-md-6 col-sm-6">

              <h3 className="footer-title">
                Categories
              </h3>

              <ul className="footer-links">

                {servCat &&
                  servCat.map((cat) => (

                    <li key={cat._id}>

                      <a href="#">
                        {cat.title}
                      </a>

                    </li>

                  ))}

              </ul>

            </div>

            {/* Contact */}
            <div className="col-lg-3 col-md-6 col-sm-6">

              <h3 className="footer-title">
                Contacts
              </h3>

              <div className="contact-item">

                <MdLocationOn />

                <span>
                  {webData?.address || "Loading..."}
                </span>

              </div>

              <div className="contact-item">

                <MdPhone />

                {webData?.phone && (

                  <a
                    href={`tel:+91${webData.phone}`}
                  >
                    +91 {webData.phone}
                  </a>

                )}

              </div>

              <div className="contact-item">

                <MdEmail />

                {webData?.email && (

                  <a
                    href={`mailto:${webData.email}`}
                  >
                    {webData.email}
                  </a>

                )}

              </div>

              {/* Dynamic Footer QR Codes */}
              <div className="footer_qr">

                {/* Business */}
                {webData?.vendor_apk_qr && (

                  <div className="qrimageall">

                    <span className="qr-name">
                      Business Apk
                    </span>

                    <a
                      href={webData?.vendor_apk_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >

                      <img
                        src={getQrUrl(
                          webData.vendor_apk_qr
                        )}
                        alt="Business APK QR"
                      />

                    </a>

                    <button
                      type="button"
                      className="qr-copy-btn"
                      onClick={() =>
                        copyLink(
                          webData?.vendor_apk_link
                        )
                      }
                    >
                      Copy Link
                    </button>

                  </div>

                )}

                {/* Android */}
                {webData?.android_apk_qr && (

                  <div className="qrimageall">

                    <span className="qr-name">
                      Android Apk
                    </span>

                    <a
                      href={webData?.android_apk_link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >

                      <img
                        src={getQrUrl(
                          webData.android_apk_qr
                        )}
                        alt="Android APK QR"
                      />

                    </a>

                    <button
                      type="button"
                      className="qr-copy-btn"
                      onClick={() =>
                        copyLink(
                          webData?.android_apk_link
                        )
                      }
                    >
                      Copy Link
                    </button>

                  </div>

                )}

                {/* iOS */}
                {webData?.ios_apk_qr && (

                  <div className="qrimageall">

                    <span className="qr-name">
                      iOS Apk
                    </span>

                    <a
                      href={webData?.ios_apk_link?.trim()}
                      target="_blank"
                      rel="noopener noreferrer"
                    >

                      <img
                        src={getQrUrl(
                          webData.ios_apk_qr
                        )}
                        alt="iOS APK QR"
                      />

                    </a>

                    <button
                      type="button"
                      className="qr-copy-btn"
                      onClick={() =>
                        copyLink(
                          webData?.ios_apk_link?.trim()
                        )
                      }
                    >
                      Copy Link
                    </button>

                  </div>

                )}

              </div>

            </div>

          </div>

          <hr className="footer-divider" />

          <div className="row align-items-center footer-bottom">

            <div className="col-lg-6">

              <div className="selector-group">

                <div className="payment-icons">

                  {paymentIcons.map((payment, index) => (

                    <span
                      key={index}
                      title={payment.name}
                    >
                      {payment.icon}
                    </span>

                  ))}

                </div>

              </div>

            </div>

            <div className="col-lg-6">

              <ul className="footer-links-bottom">

                <li>

                  <Link to="/privacy">
                    Privacy Policy
                  </Link>

                </li>

                <li>

                  <span className="text-white">
                    © {year}. All rights reserved
                  </span>

                </li>

              </ul>

            </div>

          </div>

        </div>

      </footer>

    </>
  );
}

export default Footer;